import React from "react";

function OrderBookDEXHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Order Book DEX Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              At Xeer Technology, we specialize in developing advanced Order
              Book Decentralized Exchanges (DEXs) that blend the benefits of
              traditional trading mechanisms with the advantages of blockchain
              technology.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderBookDEXHero;
